// import Server from 'Server'

const apiServers = {
  LOCAL: 'http://localhost:8002/api',
  PROD: 'https://api2.funlearning.com/api',
  DEV: 'https://api2-dev.funlearning.com/api',
  TEST: 'https://api2-staging.funlearning.com/api'
}

let apisByDomain = []

apisByDomain['localhost'] = apiServers.LOCAL
apisByDomain['localhost:8080'] = apiServers.LOCAL
apisByDomain['localhost:8081'] = apiServers.LOCAL
apisByDomain['www.funlearning.com'] = apiServers.PROD
apisByDomain['new.funlearning.com'] = apiServers.PROD
apisByDomain['new-dev.funlearning.com'] = apiServers.DEV
apisByDomain['new-staging.funlearning.com'] = apiServers.TEST

module.exports = {
  CONFIG: {
    timeout: 5000,
    withCredentials: true,
    headers: {
      // 'Content-Type': 'application/x-www-form-urlencoded'
      'Content-Type': 'application/json'
    }
  },
  // SERVER: Server,
  SERVER: apisByDomain[window.location.host],

  /* Auth */
  LOGIN: '/login',
  LOGOUT: '/logout',
  REGISTER: '/register',
  VALIDATE: '/users/validateUser',
  RESET_PASSWORD: '/users/resetpassword',
  RESET_PASSWORD_EMAIL: '/users/sendresetpassword',

  /* Manual */
  MANUAL_GET: '/manual',
  TERMS_GET: '/manual-terms',
  MANUAL_DAY_GET: '/manual-days/:dayId',
  MANUAL_UNIT_GET: '/manual-units/:unitId',
  MANUAL_RESOURCES_GET: '/manual-resources',
  MANUAL_RESOURCE_GET: '/manual-resources/:resourceId',
  MANUAL_SEARCH_GET: '/manual-days/search',

  /* User */
  USER_COURSES_GET: '/users/courses',
  USER_PROGRESS_POST: '/users/:userId/courses',
  USER_PROGRESS_GET: '/users/courses/:courseId',
  USER_PROGRESS_DELETE: '/users/:userId/courses/:courseId',
  USER_RESOURCES_GET: '/users/:userId/resources',
  USER_RESOURCES_POST: '/users/resources/:resourceId',

  /* Courses */
  COURSES_GET: '/courses',
  COURSE_GET: '/courses/:courseId?language=:langId',
  MODULE_GET: '/modules/:moduleId?language=:langId',
  LESSONS_GET: '/lessons',
  LESSON_GET: '/lessons/:lessonId?language=:langId',

  /* Resources */
  RESOURCES_GET: '/resources',
  RESOURCE_GET: '/resources/:resourceId',
  RESOURCE_GET_RELATED: '/resources/:resourceId/related',

  /* Services */
  SERVICES_GET: '/services',
  PD_GET: '/pds',
  CAMPS_GET: '/camps',
  SERVICE_GET: '/subservices/:serviceId',

  /* Profile */
  PROFILE_PATCH: '/accounts',

  /* Emails */
  CONTACT_US: '/contact-us',

  /* S3 */
  S3_UPLOAD_URL: '/upload/url',

  /* ASTRONAUT PROGRAM ID */
  AP_ID: 1

}



// WEBPACK FOOTER //
// ./src/utils/ApiConfig.js